"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var locales_json_1 = __importDefault(require("../../locales.json"));
var Calendar_1 = __importDefault(require("../Calendar"));
var Button_1 = __importDefault(require("../buttons/Button"));
var PlainButton_1 = __importDefault(require("../buttons/PlainButton"));
var ModalDialog_1 = __importDefault(require("../modals/ModalDialog"));
var FormError_1 = __importDefault(require("./FormError"));
var TimeSelect_1 = __importDefault(require("./TimeSelect"));
var Form_1 = require("./Form");
var padLeft = function (number) { return ("0" + number).slice(-2); };
var getDateWithOffset = function (value, offset) { return (new Date(+new Date(value) + offset * 60 * 1000)); };
var makeDateTime = function (value, offset) {
    if (!value) {
        return null;
    }
    var date = getDateWithOffset(value, offset);
    var components = [
        locales_json_1.default.en.calendar.monthNames[date.getUTCMonth()],
        " ",
        date.getUTCDate(),
        ", ",
        date.getUTCFullYear(),
        " ",
        date.getUTCHours() % 12 || 12,
        ":",
        padLeft(date.getUTCMinutes()),
        " ",
        date.getUTCHours() < 12 ? "AM" : "PM"
    ];
    return components.join("");
};
var makeCalendarValue = function (value, offset) {
    var date = value ? new Date(value) : new Date();
    var offsetDate = new Date(+new Date(date) + offset * 60 * 1000);
    return {
        year: offsetDate.getUTCFullYear(),
        month: offsetDate.getUTCMonth(),
        day: offsetDate.getUTCDate()
    };
};
var makeTimeSelectValue = function (value, offset) {
    if (!value) {
        return { hours: 12, minutes: 0 };
    }
    var date = new Date(value);
    var hours = ((date.getUTCHours() + Math.floor(offset / 60)) + 24) % 24;
    var minutes = Math.floor(date.getUTCMinutes() / 15) * 15 + (offset % 60);
    return { hours: hours, minutes: minutes };
};
var DateTimeField = /** @class */ (function (_super) {
    __extends(DateTimeField, _super);
    function DateTimeField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = react_1.default.createRef();
        _this.state = { open: false, touched: false };
        _this.getOffset = function () {
            var _a = _this.props.offset, offset = _a === void 0 ? -new Date().getTimezoneOffset() : _a;
            return offset;
        };
        _this.getValue = function () {
            var _a = _this.props, name = _a.name, value = _a.value, values = _a.values;
            return value || values[name];
        };
        _this.handleOpen = function () {
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            _this.setState({ open: false, touched: true });
        };
        _this.handleDateChange = function (year, month, day) {
            var offset = _this.getOffset();
            var value = _this.getValue();
            var date = getDateWithOffset(value ? new Date(value) : new Date(), offset);
            var inUTC = new Date([
                year,
                "-",
                padLeft(month + 1),
                "-",
                padLeft(day),
                "T",
                padLeft(value ? date.getUTCHours() : (12 - Math.floor(offset / 60))),
                ":",
                padLeft(value ? date.getUTCMinutes() : (0 - (offset % 60))),
                ":00",
                offset < 0 ? "-" : "+",
                padLeft(Math.abs(Math.floor(offset / 60))),
                ":",
                padLeft(Math.abs(offset % 60))
            ].join(""));
            _this.propagateChange(inUTC.getUTCFullYear(), inUTC.getUTCMonth(), inUTC.getUTCDate(), inUTC.getUTCHours(), inUTC.getUTCMinutes());
        };
        _this.handleTimeChange = function (hours, minutes) {
            var offset = _this.getOffset();
            var value = _this.getValue();
            var date = getDateWithOffset(value ? new Date(value) : new Date(), offset);
            var inUTC = new Date([
                date.getFullYear(),
                "-",
                padLeft(date.getUTCMonth() + 1),
                "-",
                padLeft(date.getUTCDate()),
                "T",
                padLeft(hours),
                ":",
                padLeft(minutes),
                ":00",
                offset < 0 ? "-" : "+",
                padLeft(Math.abs(Math.floor(offset / 60))),
                ":",
                padLeft(Math.abs(offset % 60))
            ].join(""));
            _this.propagateChange(inUTC.getUTCFullYear(), inUTC.getUTCMonth(), inUTC.getUTCDate(), inUTC.getUTCHours(), inUTC.getUTCMinutes());
            _this.handleClose();
        };
        _this.handleSelect = function () {
            var offset = _this.getOffset();
            var value = _this.getValue();
            var date = value ? new Date(value) : new Date();
            _this.propagateChange(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), value ? date.getUTCHours() : (12 - Math.floor(offset / 60)), value ? date.getUTCMinutes() : (0 - (offset % 60)));
            _this.handleClose();
        };
        _this.propagateChange = function (year, month, date, hours, minutes) {
            var _a = _this.props, name = _a.name, onChange = _a.onChange, onFormChange = _a.onFormChange;
            var value = new Date(Date.UTC(year, month, date, hours, minutes, 0)).toISOString();
            if (onChange) {
                onChange(value);
            }
            onFormChange(name, value);
        };
        return _this;
    }
    DateTimeField.prototype.componentDidMount = function () {
        var autoFocus = this.props.autoFocus;
        var button = this.buttonRef.current;
        if (autoFocus && button) {
            button.focus();
        }
    };
    DateTimeField.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, disabled = _a.disabled, name = _a.name, onFieldDisabledChange = _a.onFieldDisabledChange;
        if (prevProps.disabled !== disabled) {
            onFieldDisabledChange(name, disabled);
        }
    };
    DateTimeField.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, onError = _a.onError, name = _a.name, required = _a.required, submitted = _a.submitted, validator = _a.validator, registerModal = _a.registerModal;
        var _b = this.state, open = _b.open, touched = _b.touched;
        var offset = this.getOffset();
        var value = this.getValue();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("label", { className: classnames_1.default("chq-ffd", className), htmlFor: name },
                react_1.default.createElement("span", { className: "chq-ffd--lb" }, children),
                react_1.default.createElement(PlainButton_1.default, { ref: this.buttonRef, disabled: disabled, "aria-label": "Open calendar", className: "chq-ffd--ctrl chq-ffd--dt", onClick: this.handleOpen }, makeDateTime(value, offset)),
                react_1.default.createElement("input", { "aria-label": name, id: name, name: name, type: "hidden", value: value || "" })),
            open && (react_1.default.createElement(ModalDialog_1.default, { className: "chq-ffd--dtmd", entrance: "zoomIn", onClose: this.handleClose, registerModal: registerModal },
                react_1.default.createElement(ModalDialog_1.default.Heading, { onClose: this.handleClose }, children),
                react_1.default.createElement(ModalDialog_1.default.Body, null,
                    react_1.default.createElement(Calendar_1.default, __assign({}, makeCalendarValue(value, offset), { onChange: this.handleDateChange })),
                    react_1.default.createElement(TimeSelect_1.default, __assign({}, makeTimeSelectValue(value, offset), { onChange: this.handleTimeChange }))),
                react_1.default.createElement(ModalDialog_1.default.Footer, null,
                    react_1.default.createElement(Button_1.default, { primary: true, onClick: this.handleSelect }, "Select")))),
            react_1.default.createElement(FormError_1.default, { name: name, onError: onError, required: required, submitted: submitted, touched: touched, validator: validator, value: value })));
    };
    return DateTimeField;
}(react_1.default.Component));
exports.default = Form_1.withForm(DateTimeField);
